import "./FooterMinified.css";
import { STUDIO_LOCATOR } from "../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

const FooterMinified = () => {
  return (
    <footer className="footer-minifed">
      <div className="flex-container footer-minified-section">
        <div className="flex-item minified-left">
          <div>
            <p>AVAILIBILITY IN INTERNATIONAL CITIES</p>
          </div>
          <div>
            <p>LANGUAGE ENGLISH (CHANGE)</p>
          </div>
        </div>
        <div className="flex-item minified-right">
          <div style={{ textAlign: "right", marginRight: 20 }}>
            <a href={STUDIO_LOCATOR}>CLIENT SERVICE</a>
            <a href={STUDIO_LOCATOR}>MAKE AN APPOINTMENT</a>
            <a href={STUDIO_LOCATOR}>LEGAL NOTICES</a>
            <a href={STUDIO_LOCATOR}>ACCESSIBILITY</a>
            <a href={STUDIO_LOCATOR}>COOKIES SETTINGS</a>
          </div>
        </div>
      </div>

      <hr style={{ borderTop: "1px solid #c6c0c0", width: "100%" }} />

      <div className="flex-container footer-minified-section">
        <div className="flex-item minified-left">
          <div>
            <p>FOLLOW US </p>
          </div>
        </div>
        <div className="flex-item minified-right">
          <div className="social-icons">
            <a href="https://www.facebook.com/meridiansproperties?mibextid=kFxxJD" className="social-link">
              <FontAwesomeIcon icon={faFacebookF} className="social-icon" />
            </a>
            <a href="https://twitter.com" className="social-link">
              <FontAwesomeIcon icon={faXTwitter} className="social-icon" />
            </a>
            <a href="https://www.instagram.com/ankitatelierofficial?igsh=ejN4dGlkcnY1N2Y5&utm_source=qr" className="social-link">
              <FontAwesomeIcon icon={faInstagram} className="social-icon" />
            </a>
            <a href="https://youtube.com/@ankitdesignanddevelopmentateli?si=KDAVwF7J-e5jNqZ8" className="social-link">
              <FontAwesomeIcon icon={faYoutube} className="social-icon" />
            </a>
          </div>
        </div>
      </div>

      <hr style={{ borderTop: "1px solid #c6c0c0", width: "100%" }} />

      <div className="flex-container footer-minified-section">
        <div className="flex-item left">
          <div>
            <p>SUBSCRIBE TO THE NEWSLETTER</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterMinified;
